import isArray from 'lodash/isArray'
import isString from 'lodash/isString'

import { Segment } from 'api/Cerebro/orgScoped/segments/types'
import { date } from 'configuration/dayjs'
import { DATES } from 'const/filters'
import { PageFilters, PresetRange } from 'types'

import { getDateRangeInDays } from './dateRange'

interface SegmentAsinUsageDetails {
    userCanToggleSegmentStatus: boolean
    isAdminWorkingWithDemoSegment: boolean
}

export function getSegmentAsinUsageDetails(
    segment: Segment,
    isInternalUser: boolean = false
): SegmentAsinUsageDetails {
    const userCanToggleSegmentStatus =
        (!segment.is_demo && !isInternalUser) || isInternalUser

    const isAdminWorkingWithDemoSegment = isInternalUser && segment.is_demo

    return {
        userCanToggleSegmentStatus,
        isAdminWorkingWithDemoSegment,
    }
}

export function isSegmentDateFilterLongerThanOneYear(
    filters: PageFilters
): boolean {
    return (
        (isString(filters[DATES]) &&
            ['last_730_days', 'last_2_years'].includes(
                filters[DATES] as PresetRange
            )) ||
        (filters[DATES] &&
            isArray(filters[DATES]) &&
            date(filters[DATES][0]).isBefore(date().subtract(1, 'years')) &&
            getDateRangeInDays(filters[DATES][0], filters[DATES][1]) > 365)
    )
}
